module.exports = __webpack_public_path__ + "img/5_EN_ChineseMicrosite_Homepage_HeroImage.ec7f809a.jpg";